import React, { useState, useEffect } from "react";
import axios from "axios";

const EditQRCode = ({ qrCodeId }) => {
  const [formData, setFormData] = useState({
    category: "",
    sub_category: "",
    item_id: "",
    image: null,
    qr_code: "",
  });

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [qrCodeData, setQRCodeData] = useState(null);

  useEffect(() => {
    // Fetch QR code details
    axios.get(`http://pbhrm.com/api/qrcodes/${qrCodeId}`)
      .then((response) => {
        const { category, sub_category, item_id, image, qr_code } = response.data.data;
        setQRCodeData(response.data.data);
        setFormData({ category, sub_category, item_id, image: null, qr_code });
      })
      .catch((error) => console.error("Error fetching QR Code:", error));

    // Fetch categories
    axios.get("http://pbhrm.com/api/categories")
      .then((response) => setCategories(response.data.data))
      .catch((error) => console.error("Error fetching categories:", error));

    // Fetch subcategories
    axios.get("http://pbhrm.com/api/subcategories")
      .then((response) => setSubcategories(response.data.data))
      .catch((error) => console.error("Error fetching subcategories:", error));
  }, [qrCodeId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({ ...prevData, image: e.target.files[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("category", formData.category);
    data.append("sub_category", formData.sub_category);
    data.append("item_id", formData.item_id);
    if (formData.image) data.append("image", formData.image);

    axios.post(`http://pbhrm.com/api/qrcodes/${qrCodeId}`, data)
      .then((response) => {
        if (response.data.status === 1) {
          alert(response.data.message);
        } else {
          alert("Failed to update QR Code.");
        }
      })
      .catch((error) => console.error("Error updating QR Code:", error));
  };

  if (!qrCodeData) {
    return <p>Loading QR Code data...</p>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>Category:</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleInputChange}
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.name}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label>Subcategory:</label>
        <select
          name="sub_category"
          value={formData.sub_category}
          onChange={handleInputChange}
        >
          <option value="">Select Subcategory</option>
          {subcategories.map((sub) => (
            <option key={sub.id} value={sub.name}>
              {sub.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label>Item ID:</label>
        <input
          type="text"
          name="item_id"
          value={formData.item_id}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <label>Image:</label>
        <input type="file" name="image" onChange={handleFileChange} />
      </div>
      <div>
        <label>QR Code:</label>
        <textarea
          name="qr_code"
          value={formData.qr_code}
          readOnly
        ></textarea>
      </div>
      <button type="submit">Update QR Code</button>
    </form>
  );
};

export default EditQRCode;
